import axios from "axios";

const instance = axios.create({
  // THE API (cloud function) URL
  baseURL:'http://localhost:5001/clone-149b9/us-central1/api'

  //'https://us-central1-clone-149b9.cloudfunctions.net/api'
    
});

export default instance;
